function fire(vue, type, obj) {
  let msgobj = {
    type: type,
    message: obj,
  }
  vue.$message(msgobj)
}

function success(vue, message) {
  fire(vue, 'success', message)
}

function info(vue, message) {
  fire(vue, 'info', message)
}

function warn(vue, message) {
  fire(vue, 'warning', message)
}

function error(vue, message) {
  fire(vue, 'error', message)
}

function error_server(vue) {
  fire(vue, 'error', 'サーバ通信エラー')
}
export default {
  s: success,
  i: info,
  w: warn,
  e: error,
  e_server: error_server
}
